/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdatePackageForm = {
  /**
   * The description of the package. Limited markdown syntax is supported.
   */
  description?: string | undefined;
  /**
   * The id of the package to update
   */
  id: string;
  /**
   * The asset ID of the image to show for this package
   */
  imageAssetId?: string | undefined;
  /**
   * The keywords of the package
   */
  keywords?: Array<string> | undefined;
  /**
   * The summary of the package
   */
  summary?: string | undefined;
  /**
   * The title of the package
   */
  title?: string | undefined;
  /**
   * External URL for the package owner
   */
  url?: string | undefined;
};

/** @internal */
export type UpdatePackageForm$Outbound = {
  description?: string | undefined;
  id: string;
  image_asset_id?: string | undefined;
  keywords?: Array<string> | undefined;
  summary?: string | undefined;
  title?: string | undefined;
  url?: string | undefined;
};

/** @internal */
export const UpdatePackageForm$outboundSchema: z.ZodMiniType<
  UpdatePackageForm$Outbound,
  UpdatePackageForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    id: z.string(),
    imageAssetId: z.optional(z.string()),
    keywords: z.optional(z.array(z.string())),
    summary: z.optional(z.string()),
    title: z.optional(z.string()),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      imageAssetId: "image_asset_id",
    });
  }),
);

export function updatePackageFormToJSON(
  updatePackageForm: UpdatePackageForm,
): string {
  return JSON.stringify(
    UpdatePackageForm$outboundSchema.parse(updatePackageForm),
  );
}
